import React from "react";
import { Skeleton, Stack } from "@mui/material";

const MyOrderProductSkeleton = () => {
  return (
    <div>
      <Stack spacing={2} className="my-order-product-details">
        <Skeleton width="150px" height="200px" />
        <div
          className="product-basic-details"
          style={{
            width: "100%",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            className="product-name"
            style={{
              width: "100%",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Skeleton animation="wave" width="50%" />
          </div>
          <div
            className="product-description"
            style={{
              width: "100%",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Skeleton animation="wave" width="80%" />
          </div>
          <div
            className="product-size"
            style={{
              width: "100%",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Skeleton animation="wave" width="20%" />
          </div>
          <div
            className="product-color"
            style={{
              width: "100%",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Skeleton animation="wave" width="20%" />
          </div>
        </div>
        <Stack
          spacing={2}
          direction="row"
          className="delivery-status-container"
        >
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            animation="wave"
          />
          <div className="content" style={{ width: "100%" }}>
            <div className="delivery-status">
              <Skeleton animation="wave" width="30%" />
            </div>
            <div className="delivery-date">
              <Skeleton animation="wave" width="60%" />
            </div>
          </div>
        </Stack>
      </Stack>
    </div>
  );
};

export default MyOrderProductSkeleton;
